import { Currency } from '@debbie/common/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from './Select.js';
const CurrencySelect = (props) => {
    const lang = useSelector((state) => state.lang);
    return (React.createElement(Select, { ...props, title: lang.mentionContent.currency, label: props.label ?? lang.mentionContent.currency, searchPlaceholder: lang.misc.search, options: Object.values(Currency).map((currency) => ({
            value: currency,
            label: currency,
        })), selected: props.value == null ? [] : [props.value], onChange: (selected) => {
            const currency = Object.values(Currency).find((value) => value === selected[0]);
            if (currency !== undefined) {
                props.onChange(currency);
            }
        } }));
};
export default CurrencySelect;
//# sourceMappingURL=CurrencySelect.js.map